<template>
  <div class="myBag-wrapper">
    <div class="myBag-top">
      <Title-b title="查看到貨情況/申請集運" />
    </div>
    <div class="game">
       <!-- <Form-item :label="$t('Forecastpackage.Typeofgoods')" prop="Goodsid"> -->
      <i-select v-model="select1" :label-in-value="true" :placeholder="$t('Mypackage.choseWarehouse')" style="width: 200px;" @on-change="huoqu()" clearable>
        <i-option :value="it.ID" v-for="(it, int) in ck" :key="int">
          {{it.HouseName}}
        </i-option>
      </i-select>
              <!-- </Form-item> -->
      <i-input
        v-model="search"
        @on-change="changeSech()"
        placeholder="請輸入快遞單號"
        style="width: 300px"
      ></i-input>
      <div class="background" @click="BillCode()">
        <img src="../../../assets/images/sousuo.png" alt="" />
      </div>
    </div>
    <Tabs active-key="2" @on-click="changeTab" v-model="tabIndex">
      <!-- <Tab-pane :label="'全部(' + total.all + ')'" key="key1"></Tab-pane>
      <Tab-pane :label="'未入庫(' + total.afterAll + ')'" key="key2"></Tab-pane>
      <Tab-pane :label="'已入庫(' + total.nowAll + ')'" key="key3"></Tab-pane> -->
      <Tab-pane :label="'已入庫(' + total.nowAll +')'" key="2"></Tab-pane>
      <Tab-pane :label="'未入庫(' + total.afterAll +')'" key="3"></Tab-pane>
      <Tab-pane :label="'待集運(' + total.all +')'" key="1"></Tab-pane>
    </Tabs>
    <!-- <p class="bag_tab-p">
      注：【普貨】【特貨】不能一起集運
    </p> -->
    <Table
      border
      :loading="loading"
      :columns="columns"
      :data="list"
      style="overflow-y: hidden;"
      v-if="showTable"
      @on-selection-change="selectList"
      max-height="540"
    >
    
  </Table>
    <!-- <Table width="100%" border :columns="columns" :data="list" @on-selection-change="selectList"></Table> -->
    <!-- <Button type="primary" class="ButtonPsoss" v-show="ButtonFlase">快遞狀態</Button> -->

    <!-- <Button type="warning" size="small" class="ButtonPsoss">快遞狀態</Button> -->
    

    <r-mask title="編輯" :isShowModal="showModal" @closeMask="closeEdit">
      <i-form
        ref="formRef"
        :model="formInline"
        :rules="ruleInline"
        label-position="right"
        :label-width="100"
        inline
      >
        <Form-item label="快遞單號" prop="kdBillcode">
          <Input v-model="formInline.kdBillcode" :disabled="true" style="width: 310px" />
        </Form-item>
        <Form-item label="貨物品名">
          <!-- <Select v-model="GoosMoaol" filterable multiple style="width: 310px">
            <Option v-for="(item, idx) in goodsName" :key="idx" :value="item"
              >{{ item }}
            </Option>
          </Select> -->
          <Input
            v-model="formInline.Goods"
            placeholder="請輸入貨物品名"
            style="width: 310px"
          />
        </Form-item>
        <Form-item label="貨物價值">
          <Input
            v-model="formInline.GoodsValue"
            placeholder="請輸入貨物價值"
            style="width: 310px"
          />
        </Form-item>
        <Form-item label="貨物類型" prop="Goodsid">
          <i-select
            v-model="formInline.Goodsid"
            :label-in-value="true"
            style="width: 310px"
            placeholder="請選擇貨物類型"
            @on-change="changeSelect"
          >
            <i-option
              :value="item.GoodsID"
              v-for="(item, index) in GoodList"
              :key="index"
              >{{ item.GoodsName }}</i-option
            >
          </i-select>
        </Form-item>
        <Form-item label="貨物數量">
          <Input
            v-model="formInline.Number"
            placeholder="請輸入貨物數量"
            style="width: 310px"
          />
        </Form-item>
        <Form-item label="備註說明">
          <Input v-model="formInline.Goods_meno" style="width: 310px" />
        </Form-item>
      </i-form>
      <div class="upBtn">
        <Button-b value="提交" @click.native="handleSubmit('formRef')" />
      </div>
    </r-mask>
    <r-mask title="申請集運" :isShowModal="showApplay" @closeMask="close_btn">
      <div slot="price" class="price-title">
        <!-- 計費重量：{{this.freeAdd.Free_Weight ? this.freeAdd.Free_Weight:0}}(kg) -->
        重量：{{ this.freeAdd.Z_Weight ? this.freeAdd.Z_Weight : 0 }}(kg)
        集運費用：<span class="price">
          {{ this.freeAdd.Free ? Math.ceil(this.freeAdd.Free) : 0 }}</span >元
          ({{ this.freeAdd.CountryMoneyUnit }}:{{ this.freeAdd.CountryMoney }})
      </div>
      <div>
        <div class="pirce-wrapper">
          <div>待完成單號</div>
        </div>
      </div>
      <i-table border stripe :columns="columnsBag" :data="sList" ></i-table>
      <div class="info-form">
        <i-form ref="info" :model="info" :rules="ruleValidate2" :label-width="140">
          <Tabs active-key="2" @on-click="changeZt">
            <Tab-pane label="選擇收貨地址" key="2"></Tab-pane>
            <!-- <Tab-pane label="選擇自提點地址" key="3"></Tab-pane> -->
          </Tabs>
            <i-table
            border
            stripe
            :columns="addTable"
            :data="info.ServiceType == 2 ? addressList : ztList"
            style="margin-bottom: 20px;background:red;"
          ></i-table>

          <!-- 选择申报人 -->
          <!-- <Table border ref="selection"  @on-selection-change="handleSelect" :columns="declarantCol" :data="declarantData" max-height="200"></Table> -->

          <div
            class="info-flex"
            v-if="info.ServiceType == 3"
            style="position: relative; left: -36px"
          >
            <Form-item label="收件人姓名：">
              <i-input placeholder="請輸入收件人姓名" v-model="info.Signer"></i-input>
            </Form-item>
            <Form-item label="收件人手機：">
              <i-input placeholder="請輸入收件人手機" v-model="info.mobile"></i-input>
            </Form-item>
            <span style="font-size: 12px; position: absolute; width: 400px; right: 61px"
              >(自提件,通過此手機號發送WHATS
              APP到貨通知,如無WHATSAPP請自行到網路查閱)</span
            >
          </div>
          <div class="info-flex" style="position: relative; left: -68px">
            <Form-item label="出貨渠道">
              <i-select
                v-model="info.AirTname"
                :label-in-value="true"
                @on-change="
                  (v) => {
                    changeSelect3(v, 'AirTname');
                  }
                "
                placeholder="請選擇時效"
                style="width: 162px"
              >
                <i-option v-for="(item, index) in timeBar" :key="index" :value="item.id"
                  >{{ item.timeBarName }}
                  <span style="display: none">{{ "," + index }}</span>
                </i-option>
              </i-select>
              <p v-for="(item, index) in arrSx" :key="index" v-show="choseIndex == index">
                {{ item.Rem }}
              </p>
            </Form-item>
            <!-- <Form-item
              label="選擇承運商:"
              prop="cforhmType"
              style="position: absolute; left: 300px"
            >
              <i-select
                style="width: 162px"
                v-model="info.cforhmType"
                @on-change="changeSelect2($event, 'cforhmType')"
                placeholder="請選擇承運商"
              >
                <i-option
                  v-for="(item, index) in forwarderList"
                  :key="index"
                  :value="item.id"
                  >{{ item.ForwarderName }}</i-option
                >
              </i-select>
            </Form-item> -->
            <Form-item
              label="選擇付款方式"
              prop="PayType"
              style="position: absolute; left: 325px"
            >
              <i-select
                style="width: 162px"
                v-model="info.PayType"
                @on-change="changeSelect2($event, 'PayType')"
                placeholder="請選擇支付方式"
              >
                <!-- info.ServiceType == 3 && isDf == 0? payDf : payList" -->
                <!-- ass -->
                <i-option v-for="(item, index) in info.ServiceType == 3 && isDf == 0 ? payDf : payList" :key="index" :value="item.id">{{ item.pay }}</i-option>
              </i-select>
            </Form-item>
            <!-- <span
              style="position: absolute; width: 200px; right: 227px; color: red"
              v-show="Showzhu"
              >注:(支付寶,微信,轉數快支付會收取1%手績費(最小付款為使用PAYPAL會有手續費3.9%+$2.35手續費產生)</span
            > -->
          </div>
          <div class="info-flex" style="position: relative; left: -68px">
            <Form-item label="選擇集運券" prop="Jyj" v-show="FreessToalt">
              <i-select
                style="width: 162px"
                v-model="info.Jyj"
                @on-change="changeSelect2($event, 'Jyj')"
                placeholder="請選擇集運券"
              >
                <i-option
                  v-for="(item, index) in resList"
                  :key="index"
                  :value="item.ID"
                  v-show="ShowJyj"
                  >{{ item.newName }}</i-option
                >
              </i-select>
            </Form-item>

            <Form-item label="使用積分(選填)">
              <!-- @on-blur="sumOrderFree" -->
              <div class="tip-box">
                <i-input
                  v-model="info.Useintegral"
                  placeholder="請輸入使用的積分"
                  @on-blur="UseintFs"
                ></i-input>
                <div class="tips">
                  *{{ `當前積分${this.SuIntegral}，1積分可抵扣1元。` }}
                </div>
              </div>
            </Form-item>
            <!-- <Form-item label="保價(選填)">
              <div class="tip-box">
                <i-input
                  v-model="info.Bj"
                  placeholder="請輸入保價金額"
                  @on-blur="sumOrderFree"
                ></i-input>
                <div class="tips">
                  *{{ `保價費用：${this.freeAdd.BjFree ? this.freeAdd.BjFree : 0}` }}
                </div>
              </div>
            </Form-item> -->
            <Form-item label="代收货款(選填)">
              <!-- @on-blur="sumOrderFree" -->
              <div class="tip-box">
                <i-input
                  v-model="info.Dshk"
                  placeholder="請輸入代收货款"
                  @on-blur="sumOrderFree"
                ></i-input>
                <!--    @on-blur="sumOrderFree" -->
              </div>
            </Form-item>
          </div>
          <div class="info-flex" style="position: relative; left: -68px">
            <Form-item label="增值服務" style="width: 1000px;">
              <CheckboxGroup v-model="info.Services" @on-change="checkAllGroupChange" v-for="(item,index) in serviceList" :key="index" size="small" style="display:inline-block;margin-right:20px;">
                <Checkbox :label="item.Id" :value="item.Id">
                  <span class="serviceName">{{item.ServiceName}}</span>
                  <span>{{item.Remark}}</span>
                </Checkbox>
            </CheckboxGroup>
            </Form-item>
          </div>
          <!-- <Form-item label="備註(選填)">
            <i-input placeholder="請輸入備註" v-model="info.Dshk"></i-input>
          </Form-item> -->
          <!-- 地址选择 -->
          <div class="select-flex" v-if="info.ServiceType == 3">
            <div class="select-style">
              <div class="label">目的地：</div>
              <i-select
                v-model="addressid.Country"
                @on-change="changeAddress($event, 'Country')"
                placeholder="請選擇"
              >
                <i-option
                  v-for="(item, index) in CountryList"
                  :key="index"
                  :value="item.CountryID"
                  >{{ item.CountryName }}</i-option
                >
              </i-select>
            </div>
            <div class="select-style">
              <div class="label">省份：</div>
              <i-select
                v-model="addressid.Provice"
                @on-change="changeAddress($event, 'Provice')"
                placeholder="請選擇"
              >
                <i-option
                  v-for="(item, index) in addList.Country"
                  :key="index"
                  :value="item.CodeID"
                  >{{ item.Name }}</i-option
                >
              </i-select>
            </div>
            <div class="select-style">
              <div class="label">直轄市：</div>
              <i-select
                v-model="addressid.City"
                @on-change="changeAddress($event, 'City')"
                placeholder="請選擇"
              >
                <i-option
                  v-for="(item, index) in addList.Provice"
                  :key="index"
                  :value="item.CodeID"
                  >{{ item.Name }}</i-option
                >
              </i-select>
            </div>
            <div class="select-style">
              <div class="label">縣轄區：</div>
              <i-select
                v-model="addressid.Area"
                @on-change="changeAddress($event, 'Area')"
                placeholder="請選擇"
              >
                <i-option
                  v-for="(item, index) in addList.City"
                  :key="index"
                  :value="item.CodeID"
                  >{{ item.Name }}</i-option
                >
              </i-select>
            </div>
          </div>
     
          <Form-item>
            <i-button type="primary" class="btn-info" @click="handleSubmit('info')"
              >申請集運</i-button
            >
          </Form-item>
        </i-form>
        <Spin size="large" fix v-if="spinShow"></Spin>
      </div>
    </r-mask>
    <r-mask title="包裹圖片" :isShowModal="isShowImg" @closeMask="isShowImg = false">
      <img class="bagImg" :src="bagImg" alt="" />
    </r-mask>
    <r-mask
      title="下單成功（淘寶支付流程）"
      :isShowModal="showTaobaoCode"
      @closeMask="handleTaobao"
    >
      <div class="link-box">
        <div>ID:{{ taobaoId }}</div>
        <div>
          支付碼:{{ taobaoCode }}
          <Button-b value="複製" @click.native="copy" v-clipboard="taobaoCode"></Button-b>
        </div>
        <div class="linktaobao" @click="toLink">點擊鏈接去淘寶付款</div>
        <div>
          <p>提示：</p>
          <p>1：先複製支付碼</p>
          <p>2：點擊鏈接去淘寶付款</p>
          <p>3：拍的訂單在"買家留言"中備註所複製的支付碼</p>
        </div>
      </div>
    </r-mask>
    <r-mask title="支付寶支付" :isShowModal="isShowZfb" @closeMask="handleZfb">
      <!-- <img :src="zfbUrl" alt="图片未上传"/> -->
      <iframe class="wuliu" :src="zfbUrl"></iframe>
    </r-mask>
    <r-mask title="微信支付" :isShowModal="isShowwx" @closeMask="handleZfb" class="one">
      <div class="tip01">請打開微信掃描下方二維碼</div>
      <div id="WeChie"></div>
      <div class="tip02">支付金額：{{ this.freeAdd.Free }}元</div>
      <!-- <img :src="'data:image/png;base64,'+Familywx" alt="图片未上传" /> -->
    </r-mask>
    <!-- 轉數快 -->
    <r-mask title="轉數快" :isShowModal="isShowKZ" @closeMask="handleZfb" class="one">
      <div class="tip01">請打開轉數快掃描下方二維碼</div>
      <!-- <div id="WeChie" style="margin: 20px 0 0 104px;"></div> -->
      <img :src="'data:image/png;base64,' + KZ" alt="图片未上传" />
      <div class="tip02">支付金額：{{ this.freeAdd.Free }}元</div>
    </r-mask>
    <div class="stauts-top" v-if="this.tabIndex === 2">
      <div style="margin-right: 20px;">
        {{ $t("Mypackage.Selected") }}：{{ piece }} {{ $t("Mypackage.individual") }}，{{
          $t("Mypackage.Totalweight")
        }}：{{ weight.toFixed(2) }}kg
      </div>
      <div class="apply-btn" @click="batchUpdate" style="margin-right:10px;">
        <Button-b value="批量修改" />
      </div>
      <div class="apply-btn" @click="applay">
        <Button-b value="申請集運" />
      </div>
    </div>
    <div class="stauts-top" v-if="this.tabIndex === 0 || this.tabIndex === 1">
      <div class="apply-btn" @click="batchUpdate">
        <Button-b value="批量修改" />
      </div>
    </div>
    <!-- <div style="background:red;height:200px;width:200px">
      <img :src="'data:image/png;base64,'+KZ" alt="图片未上传" />
    </div> -->

    <!-- 批量修改货物 -->
    <r-mask title="批量修改" :isShowModal="batchShow" @closeMask="batchShow = false">
      <Form ref="batchUpdForm" :model="batchUpdForm"  :rules="ruleValidate" label-position="right" :label-width="100" inline>
        <FormItem :label="$t('Mypackage.GoodsName')" prop="GoodsName">
          <Input v-model="batchUpdForm.GoodsName" :placeholder="$t('Mypackage.InputGoodsName')" style="width: 310px"/>
        </FormItem>
        <FormItem :label="$t('Mypackage.GoodsValue')" prop="GoodsValue">
          <Input v-model="batchUpdForm.GoodsValue" :placeholder="$t('Mypackage.InputGoodsValue')" style="width: 310px"/>
        </FormItem>
        <FormItem :label="$t('Mypackage.GoodsType')" prop="GoodsTypeId">
          <Select v-model="batchUpdForm.GoodsTypeId" style="width: 310px" :placeholder="$t('Mypackage.InputGoodsType')" @on-change="changeType">
            <Option :value="(item.GoodsID).toString()" v-for="item in GoodTypeList" :key="item.GoodsID">{{ item.GoodsName }}</Option>
          </Select>
        </FormItem>
        <FormItem :label="$t('Mypackage.GoodsNum')" prop="GoodsNum">
          <Input v-model="batchUpdForm.GoodsNum" :placeholder="$t('Mypackage.InputGoodsNum')" style="width: 310px"/>
        </FormItem>
        <FormItem>
          <div class="stauts-top">
            <div class="apply-btn" @click="submitUpdate('batchUpdForm')">
              <Button-b value="提交修改" />
            </div>
          </div>
        </FormItem>
      </Form>
    </r-mask>

    <!-- 确定集运对话框 -->
    <Modal
      v-model="Showdetailed"
      title="确定集运?"
      :loading="Showdetailedloading"
      @on-ok="addOrder"
      width="800px"
    >
      <div>
        <h2 v-if="info.ServiceType == 2">
          出货渠道：{{ LabelShwo.substring(0, 6) ? LabelShwo : "送货上门" }}
        </h2>
        <h2 v-if="info.ServiceType == 3">
          出货渠道：{{ LabelShwo.substring(0, 6) ? LabelShwo : "自取" }}
        </h2>
        <!-- <i-table border stripe :columns="columnsBag" :data="sList"></i-table> -->
      </div>

      <!-- <div
        v-if="info.ServiceType == 2"
        style="margin-top: 10px; font-size: 18px; font-weight: bold; color: #e95098"
      >
        收货地址：聯系人：{{ Showps.Signer }}-- 手機號：{{ Showps.Phone }}-- 電話：{{
          Showps.Tel
        }}-- 地址：{{ Showps.CountryName }}- {{ Showps.ProviceName }}-{{
          Showps.CityName ? Showps.CityName : ""
        }}-{{ Showps.AreaName ? Showps.AreaName : "" }}-{{
          Showps.Address ? Showps.Address : ""
        }}
      </div> -->

      <h2
        v-if="info.ServiceType == 3"
        style="margin-top: 10px；font-size:18px;font-weight:bold;color:#e95098"
      >
        自提點：{{ ShowList.Name }}- 地址：{{ ShowList.Address }}- 手機號：{{
          ShowList.Phone
        }}- 電話：{{ ShowList.Tel }}- 最大重量限制：{{ ShowList.MaxWeight }}-
        最大重量限制：{{ ShowList.IsDf == 1 ? "是" : "否" }}
      </h2>

     

      <!-- <div
        v-show="ShowpsFalse"
        style="margin-top: 10px; font-size: 18px; font-weight: bold; color: #e95098"
      >
        <div v-for="(item, index) in addressList" :key="index">
          <div v-if="index < 1">
            收货地址：聯系人：{{ item.Signer }} -- 手機號：{{ addressList.Phone }} --
            電話：{{ item.Tel }} 地址：{{
              addressList.CountryName ? addressList.CountryName : ""
            }}
          </div>
        </div>
      </div> -->
    </Modal>
     <r-mask
      :title="$t('Logisticsstatus')"
      :isShowModal="isShowState"
      @closeMask="isShowState = false"
    >
      <!-- <i-table stripe :columns="columns1" :data="arr.length ? arr[0].value : []" align="center" id="mygrid"></i-table> -->
      <!-- <table v-for="(item,key) in arr" :key="key" class="center" v-if="arr.length">
            <h2 style="color:red">{{$t('OperationorderNo')}}：{{item.name}}</h2>
            <tr class="Tr">
              <td>{{$t('ClTime')}}</td>
              <td>{{$t('Clinformation')}}</td>
            </tr>
            <tr v-for="(v,index) in item.value" :key="index" class="Tr">
              <td>{{v.scan_time}}</td>
              <td>{{v.scan_memo}}</td>
            </tr>
          </table> -->
      <!-- v-if="arr.length" -->
      <Timeline v-for="(item, key) in kwidj" :key="key" v-if="kwidj.length" class="center">
        <TimelineItem v-for="(v, index) in item.data" :key="index" class="Tr">
          <div>
           <h3>{{ v.time }}</h3>
            <div style="line-height: 20px">{{ v.context }}</div>
          </div>
        </TimelineItem>
      </Timeline>
      <h1 v-if="kwidj.length == 0" class="shuju">
        {{ $t("Nodataatpresent") }}
      </h1>
    </r-mask>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import md5 from "js-md5";
import { baseInfo, delBag, AddressCol } from "./index.js";
export default {
  inject: ["reload"],
  data() {
    return {
      kwidj:[],
      search: "",
      batchShow: false,
      batchUpdForm: {},
      billCodeIdList: "",
      FreessToalt:true,
      Showdetailed: false,
      Showdetailedloading: false,
      LabelShwo: "",
      ShowpsFalse: false,
      Showps: {},
      ShowList: {},
      goodsName: [
        "衣服",
        "鞋子",
        "包包",
        "家居用品",
        "家具",
        "食品",
        "化妝品",
        "汽車用品",
        "個人護理產品",
        "文具",
        "植物",
        "廚房用品",
        "裝修建材",
        "電子產品",
        "其他",
      ],
      ButtonFlase:false,
      isShowState:false,
      columnsBag: [
        {
          title: "快遞單號",
          key: "kdBillCode",
          width: 180,
          align: "center",
        },
        {
          title: "快遞公司",
          key: "kdCompany",
          width: 100,
          align: "center",
        
        },
        // {
        //   title: "計費重量",
        //   key: "Free_Weight",
        //   width: 100,
        //   align: "center",
        // },
        {
          title: "實重",
          key: "Weight",
          width: 100,
          align: "center",
        },
        {
          title: "體積重",
          key: "Weight2",
          //   `单号:${arr.length ? arr[0].name : ''}物流状态`
          width: 100,
          align: "center",
        },

        {
          title: "尺寸（CM）",
          key: "Size",
          width: 120,
          align: "center",
        },
        {
          title: "貨物品名",
          key: "goods",
          width: 100,
          align: "center",
        },

        {
          title: "貨物類型",
          key: "goodstyep",
          // goodsName
          width: 100,
          align: "center",
        },
        // {
        //   title: "超長費",
        //   key: "longFree",
        //   width: 100,
        //   align: "center",
        // },
        {
          title: "到庫時間",
          key: "dd_time",
          width: 180,
          align: "center",
        },
        // {
        //   title: "仓租",
        //   key: "Cz",
        //   width: 100,
        //   align: "center",
        // },
        {
          title: "超长费",
          key: "LongFree",
          width: 100,
          align: "center",
        },
        // {
        //   title: "附加费",
        //   key: "AddFree",
        //   width: 100,
        //   align: "center",
        // },
      ],
      CoutnryIDchengg:0,
      addTable: [
        {
          title: "選擇",
          width: 120,
          align: "center",
          // defaultS: "",
          render: (h, params) => {
            let defaultS = false;
            let id = params.row.ID;
            let CountryID = params.row.Country;
            let _this = this;
            let type = this.info.ServiceType;
            if (type == 2) {
              defaultS = this.info.Address == id;
            }
            if (type == 3) {
              defaultS = this.info.Ztd == id;
            }
            return h("div", [
              h("Radio", {
                props: {
                  value: defaultS,
                  size: "large",
                
                },
                on: {
                  input: function () {
                    if (_this.info.ServiceType == 2) {
                      _this.info.Address = id;
                      _this.info.CountryID = CountryID;
                      _this.info.AirTname = ""
                      _this.Showps = params.row;
                      _this.info.Jyj=0;
                      if (_this.info.Address !== "") {
                        _this.sumOrderFree("add");
                      }
                    }

                    if (_this.info.ServiceType == 3) {
                      _this.info.Address = 0;
                      _this.info.Ztd = id;
                      _this.isDf = params.row.IsDf;
                      _this.ShowList = params.row;
                      if (_this.info.Ztd !== "") {
                        _this.sumOrderFree("add");
                      }
                    }
                  },
                },
              }),
            ]);
          },
        },
        {
          title: "地址",
          align: "center",
          ...AddressCol(this),
        },
        // {
        //   title: "附加費",
        //   align: "center",
        //   width: 120,
        //   render: (h, params) => {
        //     let row = params.row;
        //     let str = `HK$${row.AddFree}`;
        //     return h("span", str);
        //   },
        // },
      ],
      columns: [
        {
          type: "selection",
          width: 50,
          fixed: 'left',
          align: "center",
        },
        {
          title: "快递单号",
          key: "kdBillCode",
          width: '140',
          align: "center",
        },
        {
          title: "到庫時間",
          key: "name",
          align: "center",
          width: 160,
          ...baseInfo(),
          // render: (h, params) => {
          //   return h("span", params.row.inplaceTime ? params.row.inplaceTime : null);
          // },
        },
        // {
        //   title: "货物价值",
        //   key: "GoodsValue",
        //   width: 90,
        //   align: "center",
        //   render: (h, params) => {
        //     return h('span', {}, params.row.GoodsValue + '￥')
        //   }
        // },
        {
          title: "實際重量",
          key: "Weight",
          width: 90,
          align: "center",
          render: (h, params) => {
            return h('span', {}, params.row.Weight + 'kg')
          }
        },
        {
          title: "體積重量",
          key: "Weight2",
          width: 90,
          align: "center",
          render: (h, params) => {
            return h('span', {}, params.row.Weight2 + 'kg')
          }
        },
        {
          title: "數量",
          key: "Number",
          width: 60,
          align: "center",
        },
          {
          title: "倉庫",
          key: "HouseName",
          width: 80,
          align: "center",
        },
        {
          title: "類型",
          key: "goodsName",
          width: 60,
          align: "center",
        },
        {
          title: "品名",
          key: "goods",
          width: 80,
          align: "center",
        },
        
        {
          title: "貨物備註",
          key: "goods_memo",
          width: 80,
          align: "center",
          render: (h, params) => {
            return h("span", params.row.goods_memo ? params.row.goods_memo : "无");
          },
        },
        {
          title: "仓库備註",
          key: "memo",
          width: 80,
          align: "center",
          render: (h, params) => {
            return h("span", params.row.memo ? params.row.memo : "无");
          },
        },
        {
          title: "操作",
          width: 170,
          fixed: 'right',
          align: "center",
          ...delBag(this),
        },
      ],
      columns2: [
                    {
                        title: 'Name',
                        key: 'name',
                        width: 100,
                        fixed: 'left'
                    },
                    {
                        title: 'Age',
                        key: 'age',
                        width: 100
                    },
                    {
                        title: 'Province',
                        key: 'province',
                        width: 100
                    },
                    {
                        title: 'City',
                        key: 'city',
                        width: 100
                    },
                    {
                        title: 'Address',
                        key: 'address',
                        width: 200
                    },
                    {
                        title: 'Postcode',
                        key: 'zip',
                        width: 100
                    },
                    {
                        title: 'Action',
                        key: 'action',
                        fixed: 'right',
                        width: 120,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    }
                                }, 'View'),
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    }
                                }, 'Edit')
                            ]);
                        }
                    }
                ],
                data3: [
                    {
                        name: 'John Brown',
                        age: 18,
                        address: 'New York No. 1 Lake Park',
                        province: 'America',
                        city: 'New York',
                        zip: 100000
                    },
                    {
                        name: 'Jim Green',
                        age: 24,
                        address: 'Washington, D.C. No. 1 Lake Park',
                        province: 'America',
                        city: 'Washington, D.C.',
                        zip: 100000
                    },
                    {
                        name: 'Joe Black',
                        age: 30,
                        address: 'Sydney No. 1 Lake Park',
                        province: 'Australian',
                        city: 'Sydney',
                        zip: 100000
                    },
                    {
                        name: 'Jon Snow',
                        age: 26,
                        address: 'Ottawa No. 2 Lake Park',
                        province: 'Canada',
                        city: 'Ottawa',
                        zip: 100000
                    }
                ],
      addressid: {
        Country: 0,
        Provice: 0,
        City: 0,
        Area: 0,
      },
      addList: {
        Provice: [],
        City: [],
        Area: [],
        Country: [],
      },
      list: [],
      loading: true,
      showTable: true,
      formInline: {
        Memberid: localStorage.getItem("userID"),
        kdBillcode: "",
        Goods: [],
        Goodsid: "",
        GoodsType: "",
        Goods_meno: "",
        Number: 1,
        Immediatrly: 0,
        GoodsValue: "",
        ID: "",
        ClientName: localStorage.getItem("name"),
      },
      GoodList: [],
      GoodTypeList: [],
      showModal: false,
      ruleInline: {
        kdBillcode: [
          { required: true, message: "快遞單號不能為空！", trigger: "change" },
        ],
        // Goods: [{ required: true, message: "品名不能為空！", trigger: "change" }],
        Goodsid: [
          {
            required: true,
            message: "請選擇貨物類型",
            trigger: "change",
            type: "number",
          },
        ],
        Number: [
          {
            required: true,
            message: "貨物數量不能為空",
            trigger: "change",
            type: "string",
          },
        ],
      },
      ruleValidate: {
        GoodsName: [
          { required: true, message: this.$t('Mypackage.InputGoodsName'), trigger: "blur"},
        ],
        GoodsValue: [
          { required: true, message: this.$t('Mypackage.InputGoodsValue'), trigger: "blur"},
        ],
        GoodsNum: [
          { required: true, message: this.$t('Mypackage.InputGoodsNum'), trigger: "blur"},
        ],
        GoodsTypeId: [
          { required: true, message: this.$t('Mypackage.InputGoodsType'), trigger: "change"},
        ]
      },
      ruleValidate2: {
        AirTname: [
          {
            required: true,
            message: "請選擇時效",
            trigger: "change",
            type: "number",
          },
        ],
        cforhmType: [
          {
            required: true,
            message: "請選擇承運商",
            trigger: "change",
            type: "number",
          },
        ],
        PayType: [
          {
            required: true,
            message: "請選擇付款方式",
            trigger: "change",
            type: "number",
          },
        ],
      },
      tabIndex: 0,
      sList: [],
      showApplay: false,
      info: {
        Client: localStorage.getItem("userID") * 1, //会员ID
        BillCode: [], //快递单号集合
        WaveID: 5, //仓库ID
        AirTname: "", //	航班ID
        Address: "", //	收货地址ID
        Useintegral: 0, //使用积分数量 不使用积分时传入0
        Jyj: 0, //	集运卷ID，不使用集运券的时候传入 0
        Is_Bs: true, //  是否包税
        Bj: 0, //  保价金额
        Dshk: 0, // 代收货款
        CountryID: 0, //  国家ID
        // GoodsType: "", //	货物类型名称
        cforhmType: "", //  承运商名称
        ServiceType: 2, //	服务方式
        PayType: 2, //	支付方式
        Ztd: 0,
        mobile: "",
        Signer: "",
        come: "pc网站下单",
      },
      payDf: [
        { id: 2, pay: "余額支付" },
        { id: 3, pay: "淘寶店支付" },
          {id:4,pay:"轉賬"}
        // { id: 23, pay: "轉數快" },
        // { id: 12, pay: "支付寶" },
        // { id: 11, pay: "微信支付" },
        // { id: 66, pay: "PAYPAL/信用卡" },
      ], //支付列表
      payList: [
        { id: 1, pay: "貨到付款" },
        { id: 2, pay: "余額支付" },
        { id: 3, pay: "淘寶店支付" },
          {id:4,pay:"轉賬"}
        // { id: 23, pay: "轉數快" },
        // { id: 12, pay: "支付寶" },
        // { id: 11, pay: "微信支付" },
        // { id: 66, pay: "PAYPAL/信用卡" },
        // { id: 66, pay: "PAYPAL/信用卡" },
        // { id:26,pay:'微信端JSAPI支付'}
        // { id: 11, pay: "微信支付" },
        // { id: 12, pay: "支付寶支付" },
      ],
      isDf: 1,
      ServiceType: [
        {
          label: "送貨上門",
          value: 2,
        },
        {
          label: "自提點",
          value: 3,
        },
      ],
      declarantData: [],
      ztList: [],
      addressList: [],
      forwarderList: [],
      timeBar: [],
      freeAdd: {},
      SuIntegral: "",
      resList: [],
      currentId: 0,
      spinShow: false,
      bagImg: "",
      isShowImg: false,
      showTaobaoCode: false,
      taobaoId: "",
      taobaoCode: "",
      isShowZfb: false,
      isShowwx: false,
      isShowKZ: false,
      zfbUrl: "",
      time: "",
      key: "key1",
      active: 0,
      total: {
        all: 0,
        nowAll: 0,
        afterAll: 0,
      },
      CountryList: [],
      choseIndex: 0,
      KZ: "",
      Familywx: "",
      GoosMoaol: [],
      newPs: [],
      newZt: [],
      timer: null,
      orderId: "",
      Showzhu: false,
      ShowJyj: true,
      CountryHHH:0,
      CourOD:0,
      Dispals:false,
      ck: [],
      select1: "",
      // Familyzfb:""
      serviceList: []  //增值服务
    };
  },
  computed: {
    declarantCol() {
      return [
        {
          type: 'selection',
          width: 80,
          align: 'center'
        },
        {
          key: "RName",
          title: this.$t("Declarant.name"),
          align: "center",
        },
        {
          title: this.$t("Declarant.phone"),
          key: "Tel",
          align: "center",
        },
        {
          title: this.$t("Declarant.number"),
          key: "RIDNumber",
          align: "center",
        }
      ]
    },
    arrSx: function () {
      return this.info.CountryID == 852 ? this.newXg : this.newTw;
    },
    piece() {
      return this.sList.length;
    },
    weight() {
      let sum = 0;
      this.sList.forEach((item) => {
        sum += item.MaxWeight;
      });
      return sum;
    },
  },
  watch: {
    $route() {
      if (this.$route.query && this.$route.query.key) {
        this.changeTab(parseInt(this.$route.query.key));
      }
    },
    "info.PayType"(newVal) {
    },
  },
  created() {
    // this.queryBillCode(this.tabIndex);
    this.Showps = "";
    if (this.Showps == "") {
      this.ShowpsFalse = true;
    }
    // this.QueryGoods();
    if (this.$route.query && this.$route.query.key) {
      this.changeTab(parseInt(this.$route.query.key));
    }
    // this.queryBillCode();
    let msg = JSON.parse(localStorage.getItem("msg"));
    this.info.Signer = msg.ClientName;
    this.info.mobile = msg.Mobile;
    // if (this.info.mobile == null) {
    //   this.info.mobile == 0;
    // }
    this.QueryStateNums()
    this.getHouseList();
  },
  methods: {
    huoqu(){
    },
    //订单状态数量
    QueryStateNums() {
      var JsonData = {
        Client: localStorage.getItem('userID')
      }
      this.$post('/QueryStateNums',JsonData).then((res) => {
        if (res.data.State) {
          let arr = JSON.parse(res.data.ReturnJson);
          if (arr != {}) {
            this.total.nowAll = arr.Warehouse;
            this.total.afterAll = arr.NoWarehouse;
            this.total.all = arr.NoJiYun
          }
        }
      })
    },

    async BillCode() {
      const { data } = await this.$post("QueryBillCode", {
        BillCode: this.search,
        Client: localStorage.getItem("userID"),
        OrdeTeyp:  this.tabIndex,
        HouseId:this.select1 || 0
      });
      if (data.State) {
        this.list = JSON.parse(data.ReturnJson);
        console.log(this.list)
      }
    },
    // async BillCode() {
    //   const { data } = await this.$post("BillCode", {
    //     BillCode: this.search,
    //   });
    //   if (data.State) {
    //     this.list = JSON.parse(data.ReturnJson);
    //   }
    // },
    // 使用积分
    UseintFs(){
        if(this.info.Jyj != 0){
          this.$Message.error("積分跟集運券不能同時使用！");
          this.info.Useintegral = 0;
          return false;
        }
        if(this.info.Useintegral  > 1){
          this.$Message.error("最多只能使用1積分！");
          this.info.Useintegral = 0;
           return false;
        }
//         if(this.freeAdd.Free < 221){
//           this.$Message.error("金額小於221不能使用積分！");
//           this.info.Useintegral = 0;
//            return false;
//         }else if(this.freeAdd.Free == 221 && this.info.Useintegral  > 10){
//            this.$Message.error("最多只能使用10積分！");
//           this.info.Useintegral = 0;
//            return false;
//         }
//         else if(this.freeAdd.Free > 221 && this.freeAdd.Free < 321 &&this.info.Useintegral >10){
//            this.$Message.error("最多只能使用10積分！");
//           this.info.Useintegral = 0;
//            return false;
//         }
//         else if(this.freeAdd.Free >= 322 && this.freeAdd.Free < 421 &&this.info.Useintegral >20){
//             this.$Message.error("最多只能使用20積分！");
//             this.info.Useintegral = 0;
//             return false;
//         }
//         else if(this.freeAdd.Free >422 && this.freeAdd.Free < 621  && this.info.Useintegral >30){
//             this.$Message.error("最多只能使用30積分！");
//             this.info.Useintegral = 0;
//             return false;
//         }
//         else if(this.freeAdd.Free >= 622 && this.freeAdd.Free < 821 &&this.info.Useintegral >40){
//             this.$Message.error("最多只能使用40積分！");
//             this.info.Useintegral = 0;
//             return false;
//         }
//         else if(this.freeAdd.Free >= 822&&this.info.Useintegral >50){
//             this.$Message.error("最多只能使用50積分！");
//             this.info.Useintegral = 0;
//             return false;
//         }
        else {
          this.sumOrderFree();
        }
    },
    async sumOrderFree(change) {
      // this.$Spin.show({
      //   render: (h) => {
      //     return h("div", [
      //       h("Icon", {
      //         class: "demo-spin-icon-load",
      //         props: {
      //           type: "ios-loading",
      //           size: 22,
      //         },
      //       }),
      //       h("div", "正在加載請稍後"),
      //     ]);
      //   },
      // });
    //   // this.$Spin.show();
    //  if(this.freeAdd.Free < 100){
    //    this.info.Jyj = 0;
    //  }
      let id = [];
      for (let i = 0; i < this.sList.length; i++) {
        id.push(this.sList[i].id);
      }
      this.info.BillCode = id;
      if (
        this.info.Address == "" &&
        this.addressList.length > 0 &&
        this.info.ServiceType == 2
      ) {
        //this.info.Address = this.addressList[0].ID;
      }
      this.info.Useintegral = this.info.Useintegral * 1;
      this.info.Bj = this.info.Bj * 1;
      // this.info.WaveID = 5;
      const { data } = await this.$post("SumOrderFree", this.info);
      // if (data.State) {
        
        this.freeAdd = JSON.parse(data.ReturnJson);
        console.log(this.freeAdd)
        this.addressList = this.freeAdd.Client_Address;
        this.sList =this.freeAdd.BillCodeInfo
        // this.info.GoodsType = this.freeAdd.GoodsType;
        if (this.addressList.length) {
          this.info.CountryID = this.CountryHHH;
        }
        this.forwarderList = this.freeAdd.Forwarder;
        if(data.SuIntegral) {
          this.SuIntegral = data.SuIntegral;
        }
        if (this.freeAdd.SuIntegral) {
          this.SuIntegral = this.freeAdd.SuIntegral;
          if (this.SuIntegral < 0) {
            this.SuIntegral = 0;
          }
        }
        //获取时效列表
        this.timeBar = this.freeAdd.TimeBar.map((item) => {
          item.Name = `${item.timeBarName}(${item.Rem})`;
          return item;
        });
        // this.sList.forEach((item ) =>{
        //   if(item.goodsName == "敏感货"){
        //     this.timeBar[0].timeBarName = "";
        //     this.timeBar[0].Rem = "";
        //     this.timeBar[1].timeBarName = "";
        //     this.timeBar[1].Rem = "";
        //   }else if (item.goodsName == "特货") {
        //     this.timeBar[0].timeBarName = "";
        //     this.timeBar[0].Rem = "";
        //     this.timeBar[2].timeBarName = "";
        //     this.timeBar[2].Rem = "";
        //   } else if (item.goodsName == "普货") {
        //     this.timeBar[1].timeBarName = "";
        //     this.timeBar[1].Rem = "";
        //     this.timeBar[2].timeBarName = "";
        //     this.timeBar[2].Rem = "";
        //   }
        // })
        // if (this.freeAdd.GoodsType == "敏感货") {
        //     this.timeBar[0].timeBarName = "";
        //     this.timeBar[0].Rem = "";
        //     this.timeBar[1].timeBarName = "";
        //     this.timeBar[1].Rem = "";
        //   } else if (this.freeAdd.GoodsType == "特货") {
        //     this.timeBar[0].timeBarName = "";
        //     this.timeBar[0].Rem = "";
        //     this.timeBar[2].timeBarName = "";
        //     this.timeBar[2].Rem = "";
        //   } else if (this.freeAdd.GoodsType == "普货") {
        //     this.timeBar[1].timeBarName = "";
        //     this.timeBar[1].Rem = "";
        //     this.timeBar[2].timeBarName = "";
        //     this.timeBar[2].Rem = "";
        //   }
        // this.newXg = this.timeBar.filter((item) => {
        //   return item.timeBarName.indexOf("台湾") == -1;
        // });
        // this.newTw = this.timeBar.filter((item) => {
        //   return item.timeBarName.indexOf("香港") != -1;
        // });
        if (this.info.AirTname == "" || change) {
          this.info.AirTname = this.arrSx[0].id;
          this.info.cforhmType = this.forwarderList[0].id;
        }
        if(this.freeAdd.Free < 100 || this.info.Useintegral != 0){
          this.FreessToalt = false
          // this.$Message.error("消费金额满100才能使用集运卷");
          return false;
        }else{
          this.FreessToalt = true;
          this.queryFreightVolume();
        }
        this.$Message.error(data.MsgText);
        this.freeAdd = {};
      // }
    },
    async addOrder() {
      if (this.info.ServiceType == 3) {
        if (this.info.Signer == "" || this.info.mobile == "") {
          this.$Message.error("請填寫收件人信息!");
          return false;
        } else if (this.info.mobile == null) {
          this.$Message.error("請填寫收件人信息!");
          return false;
        }
      }
      this.spinShow = true;
      let payMeurl = {
        cancel_url: "https://member.haohong56.com/#/myOrder",
        return_url: "https://member.haohong56.com/#/myOrder",
      };
      delete this.info.Services
      let parmas =
        this.info.PayType == 66
          ? { ...this.info, ...payMeurl }
          : this.info || this.info.PayType == 55
          ? { ...this.info, ...payMeurl }
          : this.info;
      const { data } = await this.$post("AddOrder", parmas);
      if (data.State) {
        this.spinShow = false;
        this.orderId = data.MsgText;
        let type = this.info.PayType;
        if (type == 2 || type == 1) {
          // 余额支付
          this.$Message.success("集運成功！");
          this.closeMask();
          this.queryBillCode(this.tabIndex);
          this.$router.push("./myOrder");
        }
          if (type == 4) {
          // 银行转账
          this.$Message.success("集運成功！");
          this.closeMask();
          // this.queryBillCode(this.tabIndex);
          // this.$router.push("./myOrder");
          this.$router.push({
            path: "/bankTransfer",
            query: { msg: JSON.parse(data.ReturnJson) }
        
          });
        }
        if (type == 3) {
          // 淘宝店支付
          this.$Message.success("集運成功！");
          this.closeMask();
          this.taobaoCode = JSON.parse(data.ReturnJson).OrderCode;
          this.taobaoId = JSON.parse(data.ReturnJson).ID;
          this.showTaobaoCode = true;
        }
        if (type == 11) {
          // 微信支付
          this.isShowwx = true;
          // this.Familywx = data.ReturnJson
          this.$nextTick(() => {
            document.getElementById("WeChie").innerHTML = "";
            let WeChie = new QRCode("WeChie", {
              width: 150,
              height: 150,
              text: data.ReturnJson, // 二维码地址
              colorDark: "#000",
              colorLight: "#fff",
            });
          });

          this.timer = setInterval(this.QueryOrderState, 2000);
        }
        if (type == 12) {
          // 支付宝支付
          this.isShowZfb = true;
          this.zfbUrl = data.ReturnJson;
          this.timer = setInterval(this.QueryOrderState, 2000);
        }
        if (type == 23) {
          this.isShowKZ = true;
          this.KZ = data.ReturnJson;
          this.timer = setInterval(this.QueryOrderState, 2000);
        }
        if (type == 66) {
          // 支付宝支付
          this.$router.push("./myOrder");
          window.open(data.MsgText);
        }
      } else {
        this.$Message.error(data.MsgText);
      }
      this.spinShow = false;
    },
    async queryBillCode(index) {
      this.loading = true;
      const JsonData = {
        Client: localStorage.getItem("userID"),
        OrdeTeyp: index,
      };
      const { data } = await this.$post("QueryBillCode", JsonData);
      if (data.State) {
        this.list = JSON.parse(data.ReturnJson);
        console.log(this.list)
        // this.dList = this.list;
        let arr = JSON.parse(data.ReturnJson2);
        if (arr.length > 0) {
          this.total.all = arr[0].sum;
          this.total.nowAll = arr[1] && arr[1].sum;
          this.total.afterAll = arr[2] && arr[2].sum;
        }
        if (this.tabIndex == 2) {
          this.list = this.list.filter((item) => {
            // item._disabled = !item.Cotron;
            //  item._disabled = !item.Is_Yb;
            // item._disabled = !item.Is_Yb;
            item.checkboxShow = true;
            return item.inplaceTime !== null;
          });
        } else if (this.tabIndex == 0) {
          this.list = this.list.filter((item) => {
            // item._disabled = true;
            // item._disabled = !item.Cotron;
            // item.checkboxShow = true;
            return item.dd_time !== null;
          });
        } else {
          this.list.forEach((item) => {
            // item._disabled = true;
            item.checkboxShow = false;
          });
        }
        // this.list.forEach((item) => {
        //   item._disabled = !item.Cotron;
        // });
        this.loading = false;
      }
    },
    async delBillCode({ row, index }) {
      const JsonData = {
        MemberId: localStorage.getItem("userID"),
        ID: row.id,
      };
      const { data } = await this.$post("DelBillCode", JsonData);
      if (data.State) {
        this.list.splice(index, 1);
        this.$Message.success(`單號${row.kdBillCode} : 刪除成功！`);
      }
    },
    async GetTimeliness() {
      const JsonData = {
        CountryID: 852,
        WaveID: this.info.WaveID,
      };
      const { data } = await this.$post("GetTimeliness", JsonData);
      if (data.State) {
        //获取时效列表
        let arr = JSON.parse(data.ReturnJson).filter((item) => {
          return item.Name.indexOf("自取") != -1;
        });

        this.info.AirTname = arr[0].ID;
      }
    },
    async queryGoods() {
      const JsonData = {
        MemberId: localStorage.getItem("userID"),
      };
      const { data } = await this.$post("QueryGoods", JsonData);
      if (data.State) {
        this.GoodList = JSON.parse(data.ReturnJson);
        this.GoodTypeList = JSON.parse(data.ReturnJson);
      }
    },
    async upDateBag() {
      this.formInline.Number = this.formInline.Number * 1;
      // this.formInline.Goods = this.GoosMoaol.join(",");
      // if (this.formInline.Goods == "") {
      //   this.$Message.error("品名不能为空!");
      //   return false;
      // }
      const { data } = await this.$post("UpdateBillCode", this.formInline);
      if (data.State) {
        this.showModal = false;
        this.queryBillCode(this.tabIndex);
        this.$Message.success("修改成功！");
      } else {
        this.$Message.error(data.MsgText);
      }
    },
    async queryAdressByMemberID() {
      const JsonData = {
        MemberId: localStorage.getItem("userID"),
      };
      const { data } = await this.$post("QueryAdressByMemberID", JsonData);
      if (data.State) {
        this.addressList = JSON.parse(data.ReturnJson).filter((item) => {
          return item.Chk == 1;
        });
        // if (this.addressList.length == 0) {
        //   this.$Message.error("暫無可用地址，請先添加地址！");
        // } else {
        //   this.showApplay = true;
        //   this.GetAllZtd();
        //   this.getCountryList();
        // }
        this.showApplay = true;
        // this.GetAllZtd();
        this.getCountryList();
      }
    },
    async getCarrier() {
      const para = {
        AirTname: this.info.AirTname,
        WaveID: this.info.WaveID,
        CountryID: this.info.CountryID,
        CusID: localStorage.getItem("CusID"),
        Token: localStorage.getItem("token"),
      };
      const { data } = await this.$post("GetCarrier", para, true);
      if (data.State) {
        this.forwarderList = JSON.parse(data.ReturnJson);
      } else {
        // this.$Message.error(data.MsgText);
      }
    },
    async queryFreightVolume() {
      let _this = this;
      const para = {
        freight: _this.freeAdd.Z_Free,
        weight: _this.freeAdd.Z_Weight,
        token: localStorage.getItem("token"),
      };
      const { data } = await this.$post("QueryConvertibleVolume", para, true);

      if (data.State) {
        this.resList = JSON.parse(data.ReturnJson).QueryFreightVolumeinfo;
        // newName
        this.resList = this.resList.map((item, index) => {
          item.newName = `${item.VolumeCome}${item.Volume}HK$`;
          return item;
        });
      } else {
        // this.$Message.warning(data.MsgText);
      }
    },
    async GetAllZtd() {
      const { data } = await this.$post("QueryZtd", this.addressid);
      if (data.State) {
        this.ztList = JSON.parse(data.ReturnJson).ZtdInfo;
        //this.info.Ztd = this.ztList.length > 0 ? this.ztList[0].ID : 0;
        this.isDf = this.ztList.length > 0 ? this.ztList[0].IsDf : 0;
        // this.sumOrderFree(true);
        // this.ShowList = this.ztList[0];
      }
    },
    async getCountryList() {
      const params = { MemberID: localStorage.getItem("userID") };
      const { data } = await this.$post("GetCountryList", params);
      if (data.State) {
        this.CountryList = JSON.parse(data.ReturnJson);
      }
    },

    async changeAddress(e, key) {
      this.info.Address = "";
      this.info.Ztd = "";
      switch (key) {
        case "Country":
          this.addList.Provice = [];
          this.addList.City = [];
          this.addList.Area = [];
          this.addressid.Provice = 0;
          this.addressid.City = 0;
          this.addressid.Area = 0;
          break;
        case "Provice":
          this.addList.City = [];
          this.addList.Area = [];
          this.addressid.City = 0;
          this.addressid.Area = 0;
          break;
        case "City":
          this.addList.Area = [];
          this.addressid.Area = 0;
          break;
      }
      this.addressid[key] = e;
      const params = {
        ParentID: key == "Country" ? 0 : e,
        CountryID: this.addressid.Country,
      };
      this.GetAllZtd();
      const { data } = await this.$post("GetAreaByParentID", params);
      if (data.State) {
        this.addList[key] = JSON.parse(data.ReturnJson);
      }
    },

    async QueryOrderState() {
      var JsonData = {
        OrderId: this.orderId, 
      };
      const { data } = await this.$post("QueryOrderState", JsonData);
      if (data.State) {
        this.$Message.success("支付成功！");
        this.$router.push(`./myOrder`);
        window.clearInterval(this.timer);
      }
    },
    // async queryPayRequest() {
    //   var JsonData = {
    //     PayMode: this.info.PayType == 11 ? 0 : 1,
    //     OrderCode: this.time,
    //   };
    //   const { data } = await this.$post("queryPayRequest", JsonData);
    //   if (data.State) {
    //     this.$Message.success("支付成功！");
    //       this.isShowPay = false;
    //      this.showZfb = false;
    //     window.clearInterval(this.timer);
    //   }
    // },

    batchUpdate() {
      if(this.billCodeIdList) {
        this.batchShow = true
      } else {
        this.$Message.error("請選擇要修改的訂單！")
      }
    },
    //提交批量修改
    submitUpdate(batchUpdForm) {
      this.$refs[batchUpdForm].validate((valid) => {
        if(valid) {
          if(this.batchUpdForm.GoodsValue <= 0) {
            this.$Message.error("貨物價值不能小於等於零")
            return false
          }
          if(this.batchUpdForm.GoodsNum <= 0) {
            this.$Message.error("貨物數量不能小於等於零")
            return false
          }
          let params = {
            BillCodeIds: this.billCodeIdList,
            MemberId: localStorage.getItem("userID"),
            GoodsName: this.batchUpdForm.GoodsName,
            GoodsValue: this.batchUpdForm.GoodsValue,
            GoodsNums: this.batchUpdForm.GoodsNum,
            GoodsTypeId: this.batchUpdForm.GoodsTypeId,
            GoodsTypeName: this.batchUpdForm.GoodsTypeName
          }
          this.$post('/EditGoodsByBillCodes',params).then((res) => {
            if(res.data.State) {
              this.queryBillCode(this.tabIndex)
              this.batchUpdForm = {}
              this.$Message.success("修改成功")
              this.batchShow = false
            } else {
              this.$Message.error(res.data.MsgText)
            }
          })
        } else {
          this.$Message.error("請填寫完整信息");
        }
      })
    },
    changeRadio(e) {
      this.info.ServiceType = e;
    },
    applay() {
      if (this.sList.length == "") {
        this.$Message.error("請先選擇要集運的包裹！");
        return false;
      }
      let pm = this.sList.some((item) => {
        return item.goods == "";
      });
      let type = this.sList.some((item) => {
        return item.goodsName != this.sList[0].goodsName;
      });

      let GoodsValue = this.sList.some((item) => {
        return item.GoodsValue == 0;
      });
      
      if (GoodsValue) {
        this.$Message.error("貨物價值爲零不能集運!");
        return false;
      }

      if (pm) {
        this.$Message.error("貨物品名爲空不能集運!");
        return false;
      }
      // if (type) {
      //   this.$Message.error("货物类型不统一!");
      //   return false;
      // }
      this.info.WaveID = this.sList.length > 0 && this.sList[0].HouseId;
      this.queryAdressByMemberID();
      // this.getDeclarantList()   //查询申报人表格
      this.getServiceList()  //查询增值服务
    },
    
    //查询增值服务
    getServiceList() {
      let JsonData = {};
      this.$post('/GetServiceInfo',JsonData).then((res) => {
        if(res.data.State) {
          console.log(res)
          this.serviceList = JSON.parse(res.data.ReturnJson)
        }
      })
    },
    //选择增值服务
    checkAllGroupChange(val) {
      let ids = ""
      val.forEach((item) => {
        console.log(item,"item");
        this.serviceList.forEach((value,key) => {
        console.log(key,"key");
          if(item == value.Id) {
            ids = ids + value.Id + ','
          }
        })
      })
      var reg = /,$/gi
      ids = ids.replace(reg,"")
      this.$set(this.info,'ServicesId',ids)
      console.log(this.info,'this.info');
      this.sumOrderFree();
    },

    //选择申报人
    // handleSelect(item) {
    //   let ids = ""
    //   item.forEach((item) => {
    //     ids = ids + item.ID + ','
    //   });
    //   var reg = /,$/gi
    //   ids = ids.replace(reg,"")
    //   this.$set(this.info,'Receivers',ids)
    // },
    getDeclarantList() {
      let JsonData = {
        MemberId: localStorage.getItem("userID"),
        offset: 0, // 每页条数
        limit: 1000,   // 第几页
      };
      this.$post("/QueryReciver", JsonData).then((res) => {
        if (res.data.State) {
          this.declarantData = JSON.parse(res.data.ReturnJson).ReceiverInfo;
        }
      });
    },

     // 获取仓库地址
    async getHouseList() {
      const params = { MemberID: localStorage.getItem("userID") };
      const { data } = await this.$post("GetHouseList", params);
      if (data.State) {
        this.ck = JSON.parse(data.ReturnJson);
        // this.select1 = this.ck[0].ID;
      }
    },
    closeMask() {
      this.showApplay = false;
      this.initApplay();
    },
    initApplay() {
      this.info.Bj = 0;
      this.info.Useintegral = 0;
    },
    closeEdit() {
      this.showModal = false;
    },
    selectList(e) {
      let ids = ""
      this.sList = e;
      this.info.WaveID = e.length > 0 && e[0].HouseId;
      e.forEach((item) => {
        ids = ids + item.id + ','
      })
      var reg = /,$/gi
      ids = ids.replace(reg,"")
      this.billCodeIdList = ids
    },
    changeTab(e) {
      this.tabIndex = e;
      if(this.tabIndex == 1){
        this.ButtonFlase = true;
      }else{
        this.ButtonFlase = false;
      }
      this.sList = [];
      this.info.BillCode = "";
      this.queryBillCode(e);
    },
    close_btn() {
      this.showApplay = false;
      this.info.Jyj = 0;
      this.info.AirTname = "";
      this.info.cforhmType = "";
      this.info.CountryID = 0;
      this.info.ServiceType = 2;
      this.addressid.Country = 0;
      this.addressid.Provice = 0;
      this.addressid.City = 0;
      this.addressid.Area = 0;
      this.info.Address = 0;
      this.info.Ztd = 0;
    },
    changeSelect3(val, type) {
      this.LabelShwo = val.label;
      var key = val.value;
      this.CourOD = key
      this.choseIndex = val.label.split(",")[1];
      this.info[type] = key;
      if (type == "AirTname") {
        this.info.Useintegral = 0
        this.info.Jyj = 0
        this.sumOrderFree();
        this.getCarrier();
        // this.queryFreightVolume();
      }
      if (type == "PayType") {
      }
    },
    changeSelect(e) {
      this.formInline["GoodsType"] = e && e.label;
    },
    changeType(key) {
      let newGoodsTypeName = this.GoodTypeList.find(item => item.GoodsID == key)
      this.$set(this.batchUpdForm,"GoodsTypeId",key)
      this.$set(this.batchUpdForm,"GoodsTypeName",newGoodsTypeName.GoodsName)
    },
    changeSelect2(e, key) {
      // this.queryFreightVolume();
      // if (e == 3 || e == 2 || e == 1 || e == 66) {
      //   this.Showzhu = false;
      // } else {
      //   this.Showzhu = true;
      // }
      this.info[key] = e;
      if (key == "AirTname") {
        this.info.cforhmType = "";
        this.getCarrier();
      }
      console.log(this.info.Address, this.info.Ztd > 0)
      if (this.info.Address > 0 || this.info.Ztd > 0) {
        // this.Showdetailed = true;
        this.sumOrderFree();
      } else {
        this.$Message.error("請選擇您地址!");
      }
    },
    changeZt(e) {
      this.info.ServiceType = e + 2;
      this.info.Address = "";
      this.info.Ztd = "";
      this.freeAdd.Free_Weight = "";
      this.freeAdd.Free = "";
      this.freeAdd.CountryMoney = "";
      this.freeAdd.CountryMoneyUnit = "";
      if (this.arrSx.length > 0) {
        this.info.AirTname = this.arrSx[0].id;
      }
      if (e == 0) {
        this.info.Ztd = 0;
        // this.info.Address = this.addressList.length ? this.addressList[0].ID : 0;
        if (this.addressList.length == 0) {
          this.info.CountryID = 0;
        }
        // this.sumOrderFree()
      }
      if (e == 1) {
        // this.$Message.error("暫無自提點")
        // return false;
        //自提点
        // this.info.Ztd = this.ztList.length > 0 ? this.ztList[0].ID : 0;
        this.info.Address = 0;
        this.info.CountryID = 852;
        this.info.Provice = 3579;
        this.info.cforhmType = 1;
        this.GetTimeliness();
        this.changeAddress(852, "Country");
        this.changeAddress(3579, "Provice");
      }
    },
    changeModal(row) {
      this.formInline.kdBillcode = row.kdBillCode;
      this.formInline.Goods = row.goods;
      this.formInline.Goodsid = row.goods_id;
      this.formInline.GoodsType = row.goodstyep;
      this.formInline.Goods_meno = row.goods_memo;
      this.formInline.GoodsValue = row.GoodsValue;
      this.formInline.Number = JSON.stringify(row.Number);
      this.formInline.ID = row.id;
      this.showModal = true;
    },
    async showImg(row) {
      var JsonData = {
        BillCode: row.kdBillCode
      }
      const { data } = await this.$post("QueryImageByBillCode", JsonData);
      if(data.State){
        let tup = JSON.parse(data.ReturnJson);
        if(tup.length > 0) {
          this.bagImg = tup[0].pic_path;
          this.isShowImg = true;
        } else {
          this.$Message.error("該包裹暫無圖片!");
          return false;
        }
      } else {
        this.$Message.error(data.MsgText)
      }    
    },

    delModal(row) {
      this.$Modal.confirm({
        title: "提示",
        content: `確定要刪除：單號${row.row.kdBillCode}的包裹嗎？`,
        onOk: () => {
          this.delBillCode(row);
        },
        onCancel: () => {
          this.$Message.info("取消操作");
        },
      });
    },
    Expressstatus(row){
      //   document.getElementsByClassName('sdkkwodd')[0].style.color = "red"
        this.$http
        .get(
          // `http://115.29.226.122:8883/api-doc/express/gettrack?expressNo=${this.kdBillCodeID}`
          `http://115.29.226.122:8883/api/express/gettrack?expressNo=${row.row.kdBillCode}`
        )
        // http://115.29.226.122:8883/api-doc
        .then((res) => {
          if (res.data.length != 0) {
            this.isShowState = true;
            this.kwidj = res.data;
            this.$Message.error(res.data[0].message);
          }
          else {
            this.$Message.error("暂无快递信息");
          }
        });
      
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (name == "info") {
            if (this.info.Address > 0 || this.info.Ztd > 0) {
              // if(this.info.Receivers) {
                this.Showdetailed = true;
              // } else {
              //   this.$Message.error("請選擇申報人!");
              // }
            } else {
              this.$Message.error("請選擇您的自提點地址!");
            }
            // this.addOrder();
          }
          if (name == "formRef") {
            this.upDateBag();
          }
        } else {
          this.$Message.error("請將內容填寫完整!");
        }
      });
    },
    handleTaobao() {
      this.showTaobaoCode = false;
      this.$router.push(`./myOrder`);
    },
    handleZfb() {
      this.isShowZfb = false;
      this.isShowwx = false;
      this.isShowKZ = false;
      this.$router.push(`./myOrder`);
    },
    copy() {
      this.$Message.success("成功複製");
    },
    toLink() {
      this.$router.push(`./myOrder`);
      const TaoBaoUrl = localStorage.getItem("TaoBaoUrl");
      window.open(TaoBaoUrl);
    },
    changeSech() {
      if (this.search == "") {
        this.queryBillCode();
      }
    },
  },
  mounted() {
    this.queryBillCode(this.tabIndex);
    this.queryGoods();
  },
};
</script>
<style lang="scss" scoped>
.bag_tab-p {
  font-size: 26px;
  font-weight: bold;
  text-align: center;
  color: red;
}
// .freeAdd_logfe{
//     color: #333;
//     font-size: 14px;
//     position: absolute;
//     left: 90.5%;
//     top: 36%;
// }
.game {
  position: relative;
  // display: flex;
  // flex-direction: row;
  display: inline-block;
  top: 35px;
  left: 500px;
  // height: 20px;
  z-index: 3;
  .background {
    width: 63px;
    height: 31px;
    background: #ff6666;
    position: absolute;
    border-bottom-right-radius: 5px;
    border-top-right-radius: 5px;
    left: 440px;
    top: 1px;
    img {
      margin: 5px 19px;
      cursor: pointer;
    }
  }
  .ivu-select-single .ivu-select-selection {
    border: 0px solid #fff;
  }
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
.ivu-table-cell-with-selection .ivu-checkbox-wrapper {
  margin-right: 18px;
}
/deep/ .ivu-checkbox-inner {
  width: 25px !important;
  height: 25px !important;
}
/deep/ .ivu-checkbox-input {
  opacity: 1;
}
/deep/ #table {
  .ivu-table-overflowX {
    overflow-x: hidden !important;
  }
  .ivu-table-fixed-right {
    right: 0;
    //  z-index: 99;
    width: 170px !important;
  }
}
/deep/ .ivu-table-cell{
  font-size: 14px;
  padding-left: 10px;
  padding-right: 10px;
}
// /deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
//   font-weight: bold;
//   font-size: 15px;
//   color:#000;
// }

.one {
  width: 100% !important;
  /deep/ .modal-content {
    width: 30% !important;
    height: 53vh;
  }
  .tip02 {
    font-size: 16px;
    margin: 6px 0 0 0;
  }
}
/deep/ .ivu-table table {
  font-size: 14px;
}
/deep/ .ivu-form .ivu-form-item-label {
  font-size: 14px;
  padding: 10px 6px 10px 0px;
}
/deep/.ivu-tabs {
  margin: 10px 0 0 0;
}
.stauts-top {
  display: flex;
  margin: 22px 0 0 0;
  flex-direction: row;
  justify-content: flex-start;
  line-height: 40px;
  height: 40px;
  font-size: 18px;
  .apply-btn {
    width: 180px;
  }
}
.bagImg {
  width: 100%;
}
.wuliu {
  width: 600px;
  height: 600px;
  margin: 0 auto;
}
.link-box {
  padding: 20px;
  .linktaobao {
    color: #f00;
    text-decoration: underline;
    text-align: center;
    margin-top: 30px;
    cursor: pointer;
  }
  div {
    line-height: 40px;
    font-size: 28px;
  }
  p {
    line-height: 40px;
    font-size: 28px;
  }
}
.info-flex {
  color:#000;
  font-weight: bold;
  font-size: 24px;
  display: flex;
  margin-top: 10px;
  position: relative;
}
.select-flex {
  display: flex;
  margin-bottom: 20px;
  .label {
    width: 82px;
    line-height: 32px;
  }
  .select-style {
    margin-right: 10px;
    display: flex;
  }
}

.myBag-wrapper {
  background: #fff;
  border-radius: 6px;
  padding: 20px;
  min-height: 750px;
  position: relative;
  .ButtonPsoss{
    position: absolute;
    top: 262px;
    right: 37px;
    z-index: 3;
    width: 129px;
  }
  .myBag-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .modal-bag {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    overflow: auto;
    .modal-content {
      display: block;
      width: 500px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      display: flex;
      flex-direction: column;
      .frame_title {
        padding: 20px 0;
        margin: 0 30px;
        border-bottom: 1px solid #ddd;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .ft_name {
          font-size: 20px;
          font-weight: bold;
          color: rgba(34, 34, 34, 1);
        }
        .close_btn {
          width: 23px;
          height: 23px;
          cursor: pointer;
          > img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .frame-container {
        padding: 10px 30px;
        flex: 1;
        overflow: auto;
        .upBtn {
          width: 30%;
          margin: 0 auto;
        }
      }
    }
  }
}
.pirce-wrapper {
  font-size: 20px;
  color: #333;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .price {
    color: #f00;
  }
}
.price-title {
  font-size: 20px;
  color: #000;
  font-weight: bold;
  .price {
    color: #f00;
  }
}
.list-left {
  display: flex;
}
.row-left {
  width: 220px;
  color: #666;
  font-size: 12px;
  > span {
    color: #ccc;
  }
}
.info-form {
  width: 100%;
  margin: 0 auto;
  margin-top: 20px;
  .tip-box {
    position: relative;
    .tips {
      color: #f00;
      position: absolute;
      bottom: -30px;
      left: 0;
      width: 260px;
    }
  }
  .btn-info {
    width: 500px;
    height: 46px;
    margin: 30px 0 0 70px;
  }
}

#table >>> .ivu-table-body .ivu-table-cell-with-selection {
  padding: 0;
}

/deep/.ivu-checkbox-group .ivu-checkbox-group-item {
  color: #515a6e;
}

.serviceName {
  font-size: 14px;
}

// /deep/.ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
//   font-weight: normal;
//   color: #cccfda;
//   font-size: 13px;
// }
</style>



// WEBPACK FOOTER //
// src/pages/view/homeManage/myBag.vue